module.exports = __webpack_public_path__ + "assets/img/30_788.0be38bf7.jpg";